<app-header></app-header>

<ion-content scrollbar class="ion-content-padding-top-0">
  <div *ngIf="!p.renderMobile" class="breadcrumb-margin-top">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <ng-container *ngIf="!isError; else HTTPError">
    <div class="bottom-header">
      <div class="content-header">
        <div>
          <ion-icon
            class="back-provider"
            routerLink="/app/market"
            class="back-btn"
            name="chevron-back-outline"
          ></ion-icon>
          <ion-text class="header">{{provider?.name}}</ion-text>
        </div>
      </div>

      <app-search-bar
        name="sb-market"
        [permissionEdit]="addProductPermission && dictionaryServ.dictionaryMarketGroups"
        addLink="/app/market/provider/product/{{providerId}}/0"
        buttonAddLabel="{{ 'MARKET.ADD_PRODUCT' | translate}}"
        [(ngModel)]="searchValue"
        (searchEvent)="onChangeSearch($event)"
        ngDefaultControl
      >
      </app-search-bar>
    </div>

    <ion-grid>
      <ion-row>
        <ion-col class="menu">
          <div *ngIf="dictionaryServ.dictionaryMarketGroups">
            <ion-item class="header">
              <ion-text>{{ 'MARKET.CHOOSE_CATEGORY' | translate}}</ion-text>
            </ion-item>
            <ion-item
              lines="none"
              [ngClass]="{'active': 0 === groupIdClicked}"
              routerLink="/app/market/provider/{{providerId}}"
              (click)="onGroupClick(0)"
            >
              <ion-label>{{'ALL' | translate}}</ion-label>
            </ion-item>
            <ion-item
              lines="none"
              *ngFor="let item of dictionaryServ.dictionaryMarketGroups.dictionaryValues"
              (click)="onGroupClick(item.value)"
              [ngClass]="{'active': item.value === groupIdClicked}"
              routerLink="/app/market/provider/{{providerId}}"
            >
              <ion-label>{{item.key}}</ion-label>
              <ion-button
                *ngIf="addProductPermission"
                class="rounded add-to-basket"
                (click)="openEditCategory(item.id)"
              >
                <ion-icon class="outline" name="create-outline"></ion-icon>
              </ion-button>
              <ion-button
                *ngIf="addProductPermission"
                class="rounded edit"
                (click)="Delete(item.id.toString());"
              >
                <ion-icon class="outline edit" name="close-outline"></ion-icon>
              </ion-button>
            </ion-item>
          </div>
          <div *ngIf="addProductPermission">
            <ion-item
              class="new-category"
              lines="none"
              button
              (click)="openCategory()"
            >
              <ion-icon name="add"></ion-icon>
              <ion-label>{{'MARKET.ADD_CATEGORY' | translate}}</ion-label>
            </ion-item>
          </div>
        </ion-col>
        <ion-col *ngIf="productsFilter.length !== 0" class="content">
          <div>
            <div
              class="product-element"
              *ngFor="let pFilter of productsFilter"
              [ngClass]="{'move-on-hover cursor-pointer': !p.renderMobile}"
            >
              <app-product-tile
                [showEditButton]="true"
                [product]="pFilter"
                [userServ]="userService"
                (editProduct)="onEditProductClick($event)"
              ></app-product-tile>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <no-result [collection]="productsFilter"></no-result>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="MARKET.PROVIDER"
      link="app/market"
      returnText="MARKET.RETURN_TO_PROVIDER_LIST"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ng-template>
</ion-content>
